import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

// Tighter padding for table cells
const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        padding: '2px 4px',
        fontSize: '12px',
    },
    body: {
        fontSize: '12px',
        padding: '2px 4px',
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
        // Reduce row height
        height: 30,
    },
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: 850,
        borderCollapse: 'collapse',
    },
});

export default function HolidayList({ data }) {
    const classes = useStyles();
    return (
        <Table className={classes.table} aria-label="customized table" size="small">
            <TableHead>
                <TableRow>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Description</StyledTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map((row, index) => (
                    <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                            {row.Name}
                        </StyledTableCell>
                        <StyledTableCell>{row.Date}</StyledTableCell>
                        <StyledTableCell>{row.Description}</StyledTableCell>
                    </StyledTableRow>
                ))}
            </TableBody>
        </Table>
    );
}
